<template>
    <div id="divWeatherWidgetBody" class="main-weather" v-show="displayWeather">
        <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <h5 class="main-weather-color"><b>{{ $t("message.weatherTitle", { days: getDaysForForecastTitle }) }}</b></h5>
            </div>
        </div>

        <div class="row" v-show="displayNoDataAvailableMessage">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <p>{{ $t("message.noForecastDataAvailable") }}</p>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12">      
                <Carousel :autoplay="false" :nav="false" :dots="false" :items="getNumberOfDaysToDisplay" :margin="8" :loop="false"
                            :responsive="carouselResponsiveOptions" v-if="displayWeather">                     
                    <div class="day-weather text-center main-weather-color" v-for="weather in weatherData.WeatherForecastData" :key="weather.WeatherForecastId" :class="weather.CustomClass">
                        <div class="day-weather-header">
                            <label class="font-sm font-red"><b>{{ weather.HeaderTitle }}</b></label>
                        </div>

                        <div class="day-weather-content">
                            <div class="day-weather-icon">
                                <h1 class="margin-top-0"><i v-bind:class="weather.IconClassName"></i></h1>
                            </div>

                            <div class="day-weather-usage">  
                                <h3 class="margin-0"><b>{{ $n(weather.Usage, 'currency') }}</b></h3>
                                <h6 class="font-sm font-gray margin-top-0">{{ $t("message.estUsage") }}</h6>
                            </div>

                            <div class="day-weather-temps">
                                <label class="font-md"><b>{{ weather.HighTemperature }}<sup>o</sup></b></label> / <label class="font-md"><b>{{ weather.LowTemperature }}<sup>o</sup></b></label>
                            </div> 
                        </div>

                        <div class="day-weather-date">
                            <label class="font-sm font-gray font-color-custom" v-html="weather.ForecastDay"></label>
                        </div>
                    </div>                 
                </Carousel>                
            </div>
        </div>  
        <hr />
    </div>
</template>

<script>
import axios from "axios"
import Carousel from "vue-owl-carousel"

export default {
    name: 'Weather',
    components: {
        Carousel
    },
    data() {
        return {
            weatherData: {
                DisplayWeather: false,
                NumberOfDaysToDisplay: 7,
                WeatherForecastData: []
            },
            carouselResponsiveOptions: {
                0: {items: 2, dots: true},
                400: {items: 3, dots: true},
                600: {items: 3, dots: true},
                1000: {items: this.getNumberOfDaysToDisplay, dots: false}
            }
        }
    },
    mounted() {
        axios({
            method: "GET",
            url: this.$httpAxiosBaseUrl() + "Weather/GetWeatherForecast?date=" + new Date().getTime()
        }).then(result => {
            var response = result.data;

            if (response === 404) { // Error
                this.$router.push({ name: "Error" });
            } else if (response !== "") { // Success
                this.weatherData = response;
            } else { // Hide weather widget, since we didn't get any data back
                this.weatherData.DisplayWeather = false;
            }
            
        }, error => {
            console.log(error);
        })
    },
    computed: {
        displayNoDataAvailableMessage() {
            return (this.weatherData.DisplayWeather && this.weatherData.WeatherForecastData === null ) || (this.weatherData.DisplayWeather && this.getNumberOfDaysToDisplay === 0);
        },
        displayWeather() {
            return this.weatherData.DisplayWeather;
        },
        getNumberOfDaysToDisplay() {
            return this.weatherData.WeatherForecastData !== undefined ? this.weatherData.WeatherForecastData.length : this.weatherData.NumberOfDaysToDisplay;
        },
        getDaysForForecastTitle() {
            var numberOfDays = this.getNumberOfDaysToDisplay;
            return numberOfDays > 0 ? numberOfDays : "";
        }
    }
}
</script>

<style scoped>
@import url('https://cdnjs.cloudflare.com/ajax/libs/weather-icons/2.0.10/css/weather-icons-wind.min.css');
@import url('https://cdnjs.cloudflare.com/ajax/libs/weather-icons/2.0.10/css/weather-icons.min.css');

.main-weather {
    width: 96%;
    margin: 0 auto;
    padding: 15px 0 15px 0;
}

    .main-weather .owl-item {
        text-align: center;
    }

    .main-weather .owl-item:first-child .day-weather-content {
        background: #ffffff;
        border: solid 1px #f5f5f5;
    }

    .main-weather .owl-item:first-child .font-color-custom {
        color: #136aa2;
    }

    .main-weather .day-weather .day-weather-header {
        min-height: 20px;
    }

    .main-weather .day-weather .day-weather-content {
        background: #f5f6fa;
        padding-top: 15px;
        margin-bottom: 10px;
        min-height: 150px;
    }

    .main-weather .day-weather .day-weather-date label {
        width: 100%;
        margin: 0 auto;
    }

    .main-weather .day-weather h6 {
        text-transform: uppercase;
        padding: 2px 0 6px 0;
    }

    .main-weather .day-weather .day-weather-temps {
        padding-top: 2px;
    }

        .main-weather .day-weather .day-weather-temps sup {
            font-size: 62%;
            top: -0.7em;
        }

    .main-weather .main-weather-color {
        color: #136aa2;
    }

    .main-weather .day-weather-shutoff .day-weather-content {
        background: #ed1b24 !important;
    }

    .main-weather .day-weather-shutoff .day-weather-icon, .main-weather .day-weather-shutoff .day-weather-usage, .main-weather .day-weather-shutoff .day-weather-temps {
        color: #ffffff;
    }
</style>